import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PdfForm from 'components/Pdf/PdfForm';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchGeneratedInvoices } from 'slices/invoiceSlice';
import { makeInvoice } from 'slices/invoiceSlice';
import { fetchAppointClients } from 'slices/invoiceSlice';
import { invoicesSelector } from 'slices/invoiceSlice';
import jsPDF from 'jspdf';

const PdfView = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const invoiceType = queryParams.get("type");

    const invoiceRef = useRef(null);
    const { appointClients, generatedInvoices, loader } = useSelector(invoicesSelector);
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [totalDueBill, setTotalDueBill] = useState(0);
    const [isInvoiceExist, setIsInvoiceExist] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);

    useEffect(() => {
        if (generatedInvoices?.length && invoiceNumber) {
            setIsInvoiceExist(!!generatedInvoices?.find(
                i => i.invoice_number?.trim().toLowerCase() === invoiceNumber.trim().toLowerCase()
            ));
        }
    }, [generatedInvoices, invoiceNumber]);

    const apptClient = appointClients?.find(t => t.id === Number(id));
    
    const generatedInvNo = generatedInvoices.map(i => i.invoice_number);

    const generateInvoiceNumber = () => {
        let newInvoiceNumber;
        let counter = 1;
        do {
            newInvoiceNumber = `INV-${String(counter).padStart(3, '0')}`;
            counter++;
        } while (generatedInvNo.includes(newInvoiceNumber));

        return newInvoiceNumber;
    };

    useEffect(() => {
         dispatch(fetchAppointClients(1,{client_ids:id}))
        setInvoiceNumber(generateInvoiceNumber());
    }, []);

    useEffect(() => {
        const totalBill = apptClient?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0).toFixed(2);
        setTotalDueBill(totalBill);
    }, [apptClient])

    const handleGeneratePdf = () => {
        const doc = new jsPDF('p', 'pt', 'a4');

        doc.html(invoiceRef.current, {
            callback: function (doc) {
                doc.save(`${invoiceNumber}.pdf`);
            },
            margin: [7, 7, 7, 7],
            x: 7,
            y: 7,
            autoPaging: 'text',
            html2canvas: {
                scale: 0.73,
                useCORS: true
            }
        });
    };

    const submitCallback = (status, message, pdf, invoice) => {
        if (status) {
            if (pdf) {
                const link = document.createElement('a');
                link.href = `data:application/pdf;base64,${pdf}`;
                link.download = `${invoice.invoice_number}.pdf`;
                link.click();
            } else {
                handleGeneratePdf();
            }
            toast.success(message, {
                className: "successToast",
            })
            dispatch(fetchGeneratedInvoices());
            setButtonLoader(!status);
            navigate(-1)
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };
    const handleSaveInvoice = () => {
        setButtonLoader(true)
        if (!apptClient) return;
        const totalAppt = apptClient.appointments?.length || 0;
        const invoiceData = {
            client_id: id,
            invoice_number: invoiceNumber,
            total_appointments: totalAppt,
            total_due_bill: totalDueBill,
            invoice_type: invoiceType,
        };
        dispatch(makeInvoice(invoiceData, submitCallback));
    }


    return (
        <div className="content">
            {!isInvoiceExist &&
                <div className='row_savebtn'>
                    <div className='d-flex align-items-center gap-2'>
                        <button className="main_heading back_button" onClick={() => navigate(-1)}>
                            <i className="fa-solid fa-arrow-left"></i> Back
                        </button>
                    </div>
                    <SubmitButton
                        handleSubmit={handleSaveInvoice}
                        buttonType={'button'}
                        loader={buttonLoader}
                        btnText={'Save Invoice'}
                    />
                </div>
            }
            <div ref={invoiceRef} className='view_pdf_main'>
                <PdfForm data={apptClient} invoiceNumber={invoiceNumber} totalDueBill={totalDueBill} loader={loader} type={invoiceType}/>
            </div>
        </div>
    );
};

export default PdfView;
